<template>
  <v-container>
    <h1 class="text-center">Global XP Settings</h1>
    <v-form ref="form" v-model="formValid">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          :label="Waehrung"
          v-model="textValue1"
          :hint="description1" persistent-hint>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          :label="Betrag"
          :rules="rulesWith0"
          min="0"
          type="Number"
          v-model="textValue2"
          :hint="description2" persistent-hint>
        </v-text-field>
        </v-col>
        </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          :label="Limit"
          v-model="textValue3"
          :hint="description3" persistent-hint>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn color="primary" @click="saveValues">Speichern</v-btn>
      </v-col>
      </v-row>
        </v-form>
        <v-snackbar
      v-model="ErrorFlag"
      timeout="3000"
      color="red"
    >
      Überprüfe die roten Felder!

      <template v-slot:actions>
        <v-btn
          color="pink"
          variant="text"
          @click="ErrorFlag = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="GlobalXPSettingsSaved"
      timeout="3000"
      color="green"
    >
      Settings gespeichert!

      <template v-slot:actions>
        <v-btn
          color="pink"
          variant="text"
          @click="GlobalXPSettingsSaved = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
        </v-container>
        </template>

<style>
</style>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      textValue1: '',
      textValue2: '',
      textValue3: '',
      description1: 'Wie soll die XP benannt werden?',
      description2: 'Wie viel XP sollen die Viewer pro 10 min bekommen.',
      description3: 'Wie hoch soll das Limit für die XP sein?',
      Waehrung: 'Name der XP Währung',
      Betrag: 'Betrag pro 10 Minuten',
      Limit: 'Limit',
      showSavedValues: true,
      savedValues: {},
      tableHeaders: [
        { text: 'Wert', value: 'value' },
      ],
      formValid: false, // zentraler Validierungsstatus
      rulesPositiveNumber: [
        (v) => !!v || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      rulesWith0: [
        (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      ErrorFlag: false,
      GlobalXPSettingsSaved: false,
    };
  },

  mounted() {
    BackendService.loadGlobalXPSettings().then((data) => {
      const responseData = data.data;
      if (typeof responseData === 'object') {
        this.settings = [responseData]; // Objekt in ein Array umwandeln
        // console.log(this.settings); // Überprüfe das gesamte settings-Array
        this.textValue1 = this.settings[0]?.name;
        this.textValue2 = this.settings[0]?.amount;
        this.textValue3 = this.settings[0]?.global_limit;
      } else {
        // console.error('Die geladenen Daten sind kein Objekt:', responseData);
      }
    });
  },
  methods: {
    saveValues() {
      if (this.$refs.form.validate()) {
        BackendService.saveGlobalXPSettings({
          name: this.textValue1,
          amount: this.textValue2,
          global_limit: this.textValue3,
        }).then((data) => {
          this.settings = [data.data];
          // console.log(this.settings);
          this.GlobalXPSettingsSaved = true;
        }).catch(() => {
          alert('nö!');
        });
      } else this.ErrorFlag = true;
    },
  },
};
</script>
